import { render, staticRenderFns } from "./FeedTankDetail.vue?vue&type=template&id=d6f73ec0&"
import script from "./FeedTankDetail.vue?vue&type=script&lang=ts&"
export * from "./FeedTankDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports